import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-is-empty-message',
    templateUrl: './is-empty-message.component.html',
    styleUrls: ['./is-empty-message.component.css'],
    standalone: false
})
export class IsEmptyMessageComponent {
  @Input() message = 'The result is empty ...';
}
